import { canViewFiscalParametrization } from '@/features/fiscal/fiscal-place-access.js';
import { canMutateGeoCities } from '@/features/identity/geo-catalog-access.js';
import { canManageOrganizationAccess } from '@/features/identity/organization-access.js';
import { canEnterOrganizationSettings } from '@/features/organization-settings/organization-settings-access.js';
import type { ShellNavEntry } from '@/shared/shell/nav.types.js';

/** Hide nav groups the operator cannot open (parity with route guards). */
export function filterNavEntriesByRoles(
  entries: readonly ShellNavEntry[],
  roles: readonly string[],
): readonly ShellNavEntry[] {
  const canViewFiscal = canViewFiscalParametrization(roles);
  const canViewCities = canMutateGeoCities(roles);
  const canViewOrgSettings = canEnterOrganizationSettings(roles);
  const canViewOrgAccess = canManageOrganizationAccess(roles);

  return entries.filter((entry) => {
    if (entry.id === 'fiscal') {
      return canViewFiscal;
    }
    if (entry.id === 'geo-cities') {
      return canViewCities;
    }
    if (entry.id === 'org-settings') {
      return canViewOrgSettings;
    }
    if (entry.id === 'org-access') {
      return canViewOrgAccess;
    }
    return true;
  });
}
